<template>
  <div class="form-check form-switch d-flex">
    <input :id="id" class="form-check-input" :class="$attrs.class" type="checkbox" :name="name" :checked="checked" :disabled="disabled" />
    <label class="form-check-label ms-3" :class="labelClass" :for="id" :style="disabled ? 'cursor: not-allowed; opacity: 0.6;' : ''">
      <!-- <slot /> -->
       {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: "MaterialSwitch",
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    checked: {
      type: Boolean,
      default: false,
    },
    labelClass: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/* Ensure disabled checked switches show black color */
.form-check-input:checked:disabled {
  background-color: #000 !important;
  border-color: #000 !important;
  opacity: 1 !important;
}

.form-check-input:checked:disabled:after {
  border-color: #000 !important;
}
</style>
